import { keepPreviousData, queryOptions } from '@tanstack/react-query';

import type {
  BookingReservationDetail,
  BookingReservationQueryParams,
} from '@/types/api/queries';

import { HttpClient } from '@/network/HttpClient';

export const bookingReservationKeys = {
  all: () => ['bookingReservations'] as const,
  detail: (props: BookingReservationQueryParams) =>
    [...bookingReservationKeys.all(), 'detail', props.url, props.id] as const,
};

export const bookingReservationQueries = {
  detail: (props: BookingReservationQueryParams) =>
    queryOptions({
      queryKey: bookingReservationKeys.detail(props),
      queryFn: () =>
        HttpClient.request<BookingReservationDetail>({
          method: 'GET',
          url: `${props.url}/${props.id}`,
        }),
      enabled: !!props.url && !!props.id,
      placeholderData: keepPreviousData,
      refetchOnWindowFocus: true,
    }),
};
